const TEN_K = 10000;

export function generateUsername(seed: number): string
{
    const adjectives = [
        "Quick", "Brave", "Clever", "Witty", "Happy", "Chill", "Swift", "Bold", "Lucky", "Zany"
    ];

    const nouns = [
        "Fox", "Panda", "Tiger", "Eagle", "Shark", "Otter", "Wolf", "Lynx", "Hawk", "Frog"
    ];

    // Simple deterministic pseudo-random generator
    const random = (seed: number) =>
    {
        const x = Math.sin(seed) * TEN_K;

        return x - Math.floor(x);
    };

    const adjectiveIndex = Math.floor(random(seed) * adjectives.length);
    const nounIndex = Math.floor(random(seed + 1) * nouns.length);
    const numberSuffix = Math.floor(random(seed + 2) * 1000); // up to 999

    return `${adjectives[adjectiveIndex]}${nouns[nounIndex]}${numberSuffix}`;
}
